import React from 'react';
import styled from 'styled-components';
import Utility from '../../../../../util/utilityfunctions';

function PrintViewKnowledgeTitle({body}) {
	const mainBodyKey = `form-${body.id}-knowledge-title`;
	return (
		<StyledPrintViewKnowledgeTitle className="StyledPrintViewKnowledgeTitle" key={mainBodyKey}>
			{Utility.parseRichText(body.name)}
		</StyledPrintViewKnowledgeTitle>
	);
}

export default PrintViewKnowledgeTitle;

const StyledPrintViewKnowledgeTitle = styled.section`
	line-height: normal;
	width: 100%;
	font-size: var(--px-20);
	font-weight: 300;
`;
